import { hasAnyRole } from '../../utils/roles';
import { ROLES } from '../../utils/roles';

const { ROLE_OWNER, ROLE_ADMINISTRATOR, ROLE_FINANCE, ROLE_SALES_CS, ROLE_READ_ONLY } = ROLES;

const ALLOWED_ROLES_VIEW_CLIENTS = [ROLE_OWNER, ROLE_ADMINISTRATOR, ROLE_FINANCE, ROLE_SALES_CS, ROLE_READ_ONLY];

export function canViewClients(roles: string[]): boolean {
  return hasAnyRole(roles, ALLOWED_ROLES_VIEW_CLIENTS);
}
